import showToast from '../../Components/Common/SweetAlert/ToastAlert'
import { fetchAssignedTaskDetails, updateTask } from '../../redux/task/actions'
import { AppDispatch, useAppDispatch, useAppSelector } from '../../redux/store'
import { selectUserTeamMemberInfo } from '../../redux/auth/selector'
import { useLoading } from '../../context/LoadingContext'

interface UpdateTaskPayload {
  id: number
  title: string
  dueDate: Date | null
  details: string
  link: string
  importance: string
  status: string
  createdBy: string
}

const useUpdateTask = () => {
  const dispatch: AppDispatch = useAppDispatch()
  const { setLoading } = useLoading()

  const teamMemberDetails = useAppSelector(selectUserTeamMemberInfo)

  const teamMemberDetailsPayload = {
    teamMemberEmail: teamMemberDetails.email,
    teamMemberWorkdayId: teamMemberDetails.workdayId,
  }

  const handleUpdateTask = async (payload: UpdateTaskPayload) => {
    setLoading(true)
    try {
      await dispatch(updateTask({ ...payload }))
      showToast('success', 'Task updated successfully!')
    } catch (error) {
      showToast('error', 'Error updating task')
      console.error('Error updating task:', error)
    } finally {
      setLoading(false)
      await dispatch(fetchAssignedTaskDetails(teamMemberDetailsPayload)).unwrap()
    }
  }

  return {
    handleUpdateTask: handleUpdateTask,
  }
}

export default useUpdateTask
